import { makeAutoObservable, runInAction } from 'mobx';
import { getProductId } from '@/infrastructure/product-info';
import { getTapdList } from '@/presentation/components/tapd-info/api';
import { ITapdInfo } from '@/proto/manage';

export class TapdStore {
  tapdInfo: Record<string, ITapdInfo[]> = {};
  tapdList: ITapdInfo[] = [];

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  async getTapdProductList() {
    if (this.tapdInfo[getProductId()]) {
      this.tapdList = this.tapdInfo[getProductId()];
      return this.tapdList;
    }
    return await this.loadTapdProductList();
  }

  async loadTapdProductList() {
    const res = await getTapdList(getProductId());
    const tapdInfo: any = {
      ...this.tapdInfo,
      [getProductId()]: res?.tapdInfos ?? [],
    };
    runInAction(() => {
      this.tapdInfo = tapdInfo;
      this.tapdList = tapdInfo[getProductId()];
    });
    return this.tapdList;
  }
}
